import type { CheckedState } from '@radix-ui/react-checkbox';
import * as Checkbox from '@radix-ui/react-checkbox';
import type { CSSProperties } from 'react';
import { GoDash } from 'react-icons/go';
import { IoCheckmarkOutline } from 'react-icons/io5';
import { styled } from 'styled-components';
import { FuuzeColors } from '../styles/colors.js';

export type FuuzeCheckboxProps = {
  indeterminate?: boolean;
  checked?: boolean;
  onClick?: (event: unknown) => void;
  onCheckedChange?: (checked: CheckedState) => void;
  style?: CSSProperties;
};

export function FuuzeCheckbox({ indeterminate, checked, onClick, onCheckedChange, style }: FuuzeCheckboxProps) {
  return (
    <CheckboxRoot style={style} onClick={onClick} checked={checked || indeterminate} onCheckedChange={onCheckedChange}>
      <CheckboxIndicator>
        {indeterminate && <GoDash fill={FuuzeColors.dark.dark100} style={{ width: 16, height: 16 }} />}
        {checked && <IoCheckmarkOutline stroke={FuuzeColors.dark.dark100} style={{ width: 16, height: 16 }} />}
      </CheckboxIndicator>
    </CheckboxRoot>
  );
}

const CheckboxRoot = styled(Checkbox.Root)`
  border-radius: 8px;
  background-color: transparent;
  width: 24px;
  height: 24px;
  border: 1px solid ${({ theme }) => theme.colors.white};
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;

  &:hover {
    background-color: transparent;
  }

  &[data-state='checked'] {
    background-color: ${({ theme }) => theme.colors.white};

    svg {
      fill: ${({ theme }) => theme.colors.dark.dark100};
      stroke: ${({ theme }) => theme.colors.dark.dark100};
    }
  }
`;

const CheckboxIndicator = styled(Checkbox.Indicator)`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
